import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useClerk } from '@clerk/clerk-react';
import { Loader2 } from 'lucide-react';
import { useAuth } from '../App';
import { OAUTH_ROLE_KEY } from '../components/auth/GoogleButton';
import { authErrorMessage, exchangeClerkSession, routeAfterLogin } from '../lib/clerkAuth';

// Landing page after Google sign-in: swaps the Clerk session for a Zuriya one.
export default function ClerkComplete() {
  const clerk = useClerk();
  const { checkAuth } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const started = useRef(false);

  useEffect(() => {
    if (!clerk.loaded || started.current) return;
    started.current = true;
    if (!clerk.session) {
      navigate('/login', { replace: true });
      return;
    }
    const role = sessionStorage.getItem(OAUTH_ROLE_KEY) || undefined;
    sessionStorage.removeItem(OAUTH_ROLE_KEY);
    exchangeClerkSession(clerk, { role })
      .then((data) => routeAfterLogin(data, { navigate, checkAuth }))
      .catch((err) => {
        setError(authErrorMessage(err, 'We could not finish signing you in.'));
        clerk.signOut().catch(() => {});
      });
  }, [clerk, clerk.loaded, checkAuth, navigate]);

  return (
    <div className="min-h-screen bg-[#FAFAFA] flex items-center justify-center p-4" data-testid="clerk-complete-page">
      {error ? (
        <div className="card-surface p-8 max-w-md text-center">
          <p className="text-[#1A1A1A] mb-4" data-testid="clerk-complete-error">{error}</p>
          <Link to="/login" className="text-[#D4AF37] hover:underline font-medium">Back to Sign In</Link>
        </div>
      ) : (
        <div className="flex items-center gap-3 text-stone-500">
          <Loader2 className="h-5 w-5 animate-spin text-[#D4AF37]" /> Signing you in...
        </div>
      )}
    </div>
  );
}
